<!-- Skip navigation link — first focusable element in DOM (spec §11, AC-8) -->
<a class="skip-nav" href="#main-content">Skip to main content</a>

<!-- Sidebar — fixed, full viewport height, anchored to left edge -->
<app-sidebar
  [collapsed]="false"
  [activeIndex]="activeStageIndex()"
  (stageSelected)="onStageSelected($event)" />

<!-- Content column — occupies all space to the right of the sidebar -->
<div class="content-column" data-testid="app-shell">

  <!-- Prototype banner — spans full width of content column -->
  <app-prototype-banner />

  <!-- Toolbar — page title and profile icon, scoped to content column -->
  <app-toolbar [pageTitle]="pageTitle()" />

  <!-- Main content area — router outlet, fills remaining height -->
  <main id="main-content" class="main-content">
    <router-outlet />
  </main>

  <!-- Persistent Graphite footer -->
  <app-footer />

</div>
